import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState, useEffect } from "react";
import { API } from "../../Redux/actions/API";
// import { ToastContainer, toast } from 'react-toastify';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { useNavigate } from "react-router-dom";

function Reply() {
  const { userId } = useSelector((state) => state.Auth);
    const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState(searchParams.get("Id"));
  const [subject, setSub] = useState("");
  const [query, setQuery] = useState("");
  const [reply, setReply] = useState("");

  const Massage_API = async () => {
    try {
      let res = await API.post(
        `/UpdateHelpdeskByAdmin`,
        {
          loginid: userId,
          id: id,
          reply: reply,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      //console.log("res", res);
      if (res.data.data === "success") {
        toast.success("Reply Successfully !!");
        setTimeout(() => {
          navigate("/HelpDesk");
        }, 1000);
      } else {
        toast.error(res.data.data);
      }
    } catch (e) {
      console.log("Somthing Error in Massage API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  //   const handleInputChange = (event) => {
  //     const newValue = event.target.value.replace(/[^a-z0-9 ]/gi, "");
  //     setRank(newValue);
  //   };

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        `/GetHelpdeskuserById`,
        {
          id: id,
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      
      responceRight = responceRight?.data?.data[0][0];
      console.log("responceRight", responceRight);
      setQuery(responceRight.query);
      setSub(responceRight.user_id);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Reply Form</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">Reply Message</h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="User Id"
                                    // maxLength="50"
                                    value={subject}
                                    // onChange={handleInputChange}
                                    readOnly
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Query</label>
                                  <textarea
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Query"
                                    value={query}
                                    // onChange={handleInputChange}
                                    readOnly
                                  />
                                </div>

                                <div className="form-group">
                                  <label> Reply Message</label>
                                  <textarea
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Reply Message"
                                    onChange={(e) => setReply(e.target.value)}
                                  />
                                </div>

                                <div class="joinbtn d-flex flex-row-reverse me-auto ">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Massage_API()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div class="col-md-6">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">Image Table</h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <!---onclick number increase start-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default Reply;
